import React from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@carnica/ui-kit';
import { connect } from 'react-redux';
import { selectAccountType, selectPersonalBalance, selectUniBalancesError, selectUniBalancesPending } from "../../store/selectors";
import { BalanceByDate } from "./components/BalanceByDate";
import styles from "./styles.pcss";
import { pushFubAnalytics } from "../../utils/analytics";
import { ANALYTICS_ACTION, ANALYTICS_ITEM_TYPE } from "../../constants/analytics";
import { Skeleton } from "../../../common/Skeleton";
import { selectBaseUrl } from "../../../../../store/selectors";
var cn = classNames.bind(styles);
var _Balance = function _Balance(_ref) {
  var isError = _ref.isError,
    lastDate = _ref.lastDate,
    isPending = _ref.isPending,
    target = _ref.target,
    userType = _ref.userType,
    baseUrl = _ref.baseUrl,
    personalBalance = _ref.personalBalance;
  var handlePaymentClick = function handlePaymentClick() {
    pushFubAnalytics(target, {
      account_type: userType,
      action: ANALYTICS_ACTION.CLICK,
      item_type: ANALYTICS_ITEM_TYPE.BUTTON,
      button_text: 'пополнить'
    });
    window.location.href = "".concat(baseUrl, "?payment");
  };
  if (isError) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('wrap'),
      "data-t-id": "components-Balance"
    }, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u043B\u0441\u044F, \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443");
  }
  if (isPending) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('block')
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: cn('first')
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: cn('second')
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrap')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, personalBalance && /*#__PURE__*/React.createElement("div", {
    className: cn('balance-bar')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: "xs"
  }, "\u043B\u0438\u0447\u043D\u044B\u0439 \u0431\u0430\u043B\u0430\u043D\u0441"), /*#__PURE__*/React.createElement(Text, {
    size: "m"
  }, personalBalance.balanceValue, " \u20BD")), (personalBalance === null || personalBalance === void 0 ? void 0 : personalBalance.refillable) && /*#__PURE__*/React.createElement(Button, {
    className: cn('btn'),
    onClick: handlePaymentClick,
    size: "m"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary-invert",
    size: "xs",
    weight: "medium",
    "data-t-id": "components-Balance"
  }, "\u043F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C"))), !!lastDate && /*#__PURE__*/React.createElement(BalanceByDate, {
    lastDate: lastDate
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var _selectPersonalBalanc;
  return {
    personalBalance: selectPersonalBalance(state),
    lastDate: (_selectPersonalBalanc = selectPersonalBalance(state)) === null || _selectPersonalBalanc === void 0 ? void 0 : _selectPersonalBalanc.lastDate,
    isPending: selectUniBalancesPending(state),
    isError: selectUniBalancesError(state),
    userType: selectAccountType(state),
    baseUrl: selectBaseUrl(state)
  };
};
export var Balance = connect(mapStateToProps)(_Balance);